document.addEventListener('DOMContentLoaded', function() {
  
  // --------------------------------------------------------------------------
  // 1. Tilt Effect Logic
  // --------------------------------------------------------------------------
  window.initTiltEffect = function() {
    const cards = document.querySelectorAll('.product-card');
    cards.forEach(card => {
      // Prevent adding multiple glares if called again
      if(!card.querySelector('.card-glare')) {
        const glare = document.createElement('div');
        glare.className = 'card-glare';
        card.appendChild(glare);
      }
      
      const glare = card.querySelector('.card-glare');

      // Remove existing listener reference if re-initialized
      card.onmousemove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const px = x / rect.width;
        const py = y / rect.height;
        
        const maxTilt = 6;
        const rotateX = (0.5 - py) * (maxTilt * 2);
        const rotateY = (px - 0.5) * (maxTilt * 2);

        card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`;
        
        if(glare) {
          glare.style.background = `radial-gradient(circle at ${px * 100}% ${py * 100}%, rgba(255,255,255,0.12), transparent 55%)`;
        }
      };

      card.onmouseleave = () => {
        card.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)`;
        if(glare) glare.style.background = 'transparent';
      };
    });
  };

  // Initialize on page load
  window.initTiltEffect();

  // --------------------------------------------------------------------------
  // 2. Cart Drawer Logic & Real-time Synchronization
  // --------------------------------------------------------------------------
  window.openCart = function() {
    const overlay = document.querySelector('.cart-drawer-overlay');
    const drawer = document.querySelector('.cart-drawer');
    if(overlay) overlay.classList.add('open');
    if(drawer) drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    if(window.lucide) window.lucide.createIcons();
  };

  window.closeCart = function() {
    const overlay = document.querySelector('.cart-drawer-overlay');
    const drawer = document.querySelector('.cart-drawer');
    if(overlay) overlay.classList.remove('open');
    if(drawer) drawer.classList.remove('open');
    document.body.style.overflow = '';
  };

  window.updateHeaderCartCount = function(count) {
    const badges = document.querySelectorAll('[data-cart-count], .utility-cart b, .utility-cart span.cart-count');
    badges.forEach(b => {
      b.textContent = count;
      b.style.display = count > 0 ? '' : 'none';
      b.classList.remove('badge-pop');
      void b.offsetWidth;
      b.classList.add('badge-pop');
    });
  };

  window.refreshCartDrawer = function(shouldOpen = true) {
    const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    
    // Update count from /cart.js
    fetch(rootUrl + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        if (typeof cart.item_count !== 'undefined') {
          window.updateHeaderCartCount(cart.item_count);
        }
      })
      .catch(console.error);

    // Re-render cart-drawer section
    return fetch(rootUrl + '?section_id=cart-drawer')
      .then(res => res.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const newDrawer = html.querySelector('.cart-drawer');
        const currentDrawer = document.querySelector('.cart-drawer');
        if(currentDrawer && newDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }
        if(window.lucide) window.lucide.createIcons();
        if(shouldOpen) window.openCart();
      })
      .catch(err => {
        console.error('Failed to reload cart drawer:', err);
        if(shouldOpen) window.openCart();
      });
  };

  // --------------------------------------------------------------------------
  // 3. Quickview Modal Logic
  // --------------------------------------------------------------------------
  window.openQuickview = function() {
    const overlay = document.querySelector('.quickview-overlay');
    const modal = document.querySelector('.quickview-modal');
    if(overlay) overlay.classList.add('open');
    if(modal) modal.classList.add('open');
    document.body.style.overflow = 'hidden';
    if(window.lucide) window.lucide.createIcons();
  };

  window.closeQuickview = function() {
    const overlay = document.querySelector('.quickview-overlay');
    const modal = document.querySelector('.quickview-modal');
    if(overlay) overlay.classList.remove('open');
    if(modal) modal.classList.remove('open');
    document.body.style.overflow = '';
  };

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  let currentInventoryMap = {};
  
  function updateQuickviewState(variantId, isAvailable) {
    const inv = currentInventoryMap[variantId];
    const qtyInput = document.getElementById('quickview-qty');
    const addBtn = document.querySelector('.btn-quickview-add');
    const stockLabel = document.getElementById('quickview-stock-label');
    
    if(qtyInput && addBtn) {
      if(!isAvailable) {
        qtyInput.value = 0;
        qtyInput.disabled = true;
        qtyInput.max = 0;
        addBtn.disabled = true;
        addBtn.textContent = 'Out of Stock';
        if(stockLabel) stockLabel.textContent = 'Out of stock';
      } else {
        qtyInput.value = 1;
        qtyInput.disabled = false;
        if (inv && inv.policy === 'deny' && inv.qty > 0) {
          qtyInput.max = inv.qty;
          if(stockLabel) stockLabel.textContent = `Only ${inv.qty} left in stock`;
        } else {
          qtyInput.removeAttribute('max');
          if(stockLabel) stockLabel.textContent = 'In stock';
        }
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart';
      }
    }
  }

  window.populateQuickview = function(handle, inventoryData, triggerBtn) {
    if (!handle) return;
    
    currentInventoryMap = {};
    if(inventoryData) {
      inventoryData.split(',').forEach(item => {
        const parts = item.split(':');
        if(parts.length >= 4) {
          currentInventoryMap[parts[0]] = {
            qty: parseInt(parts[1]) || 0,
            policy: parts[2],
            management: parts[3]
          };
        }
      });
    }

    const origBtnText = triggerBtn ? triggerBtn.innerHTML : '';
    if (triggerBtn) {
      triggerBtn.innerHTML = '<span style="opacity:0.7">Loading...</span>';
      triggerBtn.style.pointerEvents = 'none';
    }

    const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    const productUrl = rootUrl + 'products/' + handle + '.js';

    fetch(productUrl)
      .then(res => {
        if (!res.ok) throw new Error('Product fetch failed: ' + res.status);
        return res.json();
      })
      .then(product => {
        if (triggerBtn) {
          triggerBtn.innerHTML = origBtnText;
          triggerBtn.style.pointerEvents = 'auto';
        }

        const imgEl = document.getElementById('quickview-img');
        if(imgEl && product.featured_image) {
          imgEl.src = product.featured_image;
          imgEl.alt = product.title || '';
        }
        
        const brandEl = document.getElementById('quickview-brand');
        if(brandEl) brandEl.textContent = product.vendor || '';

        const titleEl = document.getElementById('quickview-title');
        if(titleEl) titleEl.textContent = product.title || '';
        
        let firstAvailableIdx = (product.variants && product.variants.length) 
          ? product.variants.findIndex(v => v.available) 
          : -1;
        if (firstAvailableIdx === -1) firstAvailableIdx = 0;
        const firstVariant = (product.variants && product.variants.length) ? product.variants[firstAvailableIdx] : null;
        
        const priceOldEl = document.getElementById('quickview-price-old');
        const priceCurEl = document.getElementById('quickview-price-current');

        if (firstVariant) {
          if(priceOldEl) {
            priceOldEl.textContent = (firstVariant.compare_at_price > firstVariant.price) 
              ? formatMoney(firstVariant.compare_at_price) 
              : '';
          }
          if(priceCurEl) {
            priceCurEl.textContent = formatMoney(firstVariant.price);
          }
        }
        
        if (product.variants && product.variants.length) {
          const optionsHtml = product.variants.map((v, idx) => {
            const activeClass = idx === firstAvailableIdx ? 'active' : '';
            const opacityStyle = !v.available ? 'style="opacity:0.5;"' : '';
            return `<button type="button" class="variant-btn ${activeClass}" data-id="${v.id}" data-price="${v.price}" data-compare="${v.compare_at_price || ''}" data-available="${v.available}" ${opacityStyle}>${v.title}</button>`;
          }).join('');
          const optionsContainer = document.getElementById('quickview-variant-options');
          if(optionsContainer) optionsContainer.innerHTML = optionsHtml;
        }
        
        const varIdInput = document.getElementById('quickview-variant-id');
        if(varIdInput && firstVariant) varIdInput.value = firstVariant.id;
        
        const detailsLink = document.getElementById('quickview-details-link');
        if(detailsLink) detailsLink.href = product.url || (rootUrl + 'products/' + handle);
        
        const qvWishlistBtn = document.getElementById('quickview-wishlist-btn');
        if (qvWishlistBtn && firstVariant) {
          qvWishlistBtn.setAttribute('data-product-handle', product.handle);
          qvWishlistBtn.setAttribute('data-product-id', product.id);
          qvWishlistBtn.setAttribute('data-product-title', product.title);
          qvWishlistBtn.setAttribute('data-product-vendor', product.vendor || '');
          qvWishlistBtn.setAttribute('data-product-price', formatMoney(firstVariant.price));
          qvWishlistBtn.setAttribute('data-product-price-raw', firstVariant.price);
          qvWishlistBtn.setAttribute('data-product-compare', firstVariant.compare_at_price ? formatMoney(firstVariant.compare_at_price) : '');
          qvWishlistBtn.setAttribute('data-product-image', product.featured_image || '');
          qvWishlistBtn.setAttribute('data-product-url', product.url || (rootUrl + 'products/' + handle));
          qvWishlistBtn.setAttribute('data-product-available', String(product.available));
          if (window.PAD_Wishlist) window.PAD_Wishlist.updateButtons();
        }
        
        if (firstVariant) {
          updateQuickviewState(firstVariant.id, firstVariant.available);
        }
        
        window.openQuickview();
      })
      .catch(err => {
        console.warn('Quickview failed, navigating to product page:', err);
        if (triggerBtn) {
          triggerBtn.innerHTML = origBtnText;
          triggerBtn.style.pointerEvents = 'auto';
        }
        // Fallback directly to product page
        window.location.href = rootUrl + 'products/' + handle;
      });
  };

  // --------------------------------------------------------------------------
  // 4. Event Delegation: Clicks, Submits, and Cart Updates
  // --------------------------------------------------------------------------
  document.addEventListener('click', function(e) {
    // Open cart drawer from header utility
    const cartTrigger = e.target.closest('.utility-cart') || e.target.closest('[data-utility-action="Cart"]');
    if (cartTrigger) {
      e.preventDefault();
      window.refreshCartDrawer(true);
      return;
    }

    // Close cart drawer
    if (e.target.closest('.btn-close-cart') || e.target.classList.contains('cart-drawer-overlay')) {
      e.preventDefault();
      window.closeCart();
      return;
    }

    // Close quickview
    if (e.target.closest('.btn-close-quickview') || e.target.classList.contains('quickview-overlay')) {
      e.preventDefault();
      window.closeQuickview();
      return;
    }

    // Options button on card -> Open quickview
    const btnOptions = e.target.closest('.btn-options') || e.target.closest('.product-card-button--options') || e.target.closest('[data-product-handle]');
    if(btnOptions && !btnOptions.hasAttribute('data-wishlist-btn') && !btnOptions.classList.contains('card-wishlist-btn')) {
      e.preventDefault();
      const handle = btnOptions.getAttribute('data-product-handle');
      const inventoryData = btnOptions.getAttribute('data-inventory');
      if(handle) window.populateQuickview(handle, inventoryData, btnOptions);
      return;
    }

    // Quickview modal variant selector buttons
    const variantBtn = e.target.closest('.variant-btn');
    if(variantBtn && !variantBtn.hasAttribute('disabled')) {
      e.preventDefault();
      document.querySelectorAll('#quickview-variant-options .variant-btn').forEach(b => b.classList.remove('active'));
      variantBtn.classList.add('active');
      const variantId = variantBtn.getAttribute('data-id');
      const varInput = document.getElementById('quickview-variant-id');
      if(varInput) varInput.value = variantId;
      
      const price = parseInt(variantBtn.getAttribute('data-price'));
      const compareStr = variantBtn.getAttribute('data-compare');
      const compare = compareStr ? parseInt(compareStr) : null;
      const isAvailable = variantBtn.getAttribute('data-available') === 'true';
      
      const priceCurEl = document.getElementById('quickview-price-current');
      const priceOldEl = document.getElementById('quickview-price-old');
      if(priceCurEl) priceCurEl.textContent = formatMoney(price);
      if(priceOldEl) {
        priceOldEl.textContent = (compare && compare > price) ? formatMoney(compare) : '';
      }
      
      updateQuickviewState(variantId, isAvailable);
      return;
    }

    // Direct Add button on product cards (single variant)
    const btnAddDirect = e.target.closest('.btn-add-direct') || e.target.closest('.product-card-button:not(.product-card-button--options)') || e.target.closest('[data-variant-id]');
    if(btnAddDirect && !btnAddDirect.classList.contains('variant-btn') && !btnAddDirect.classList.contains('btn-quickview-add')) {
      e.preventDefault();
      const variantId = btnAddDirect.getAttribute('data-variant-id');
      if (!variantId || variantId === 'dummy') return;

      const originalContent = btnAddDirect.innerHTML;
      btnAddDirect.innerHTML = '<span style="opacity:0.7">Adding...</span>';
      btnAddDirect.style.pointerEvents = 'none';

      const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => {
        if (!res.ok) return res.json().then(err => { throw err; });
        return res.json();
      })
      .then(() => {
        btnAddDirect.innerHTML = originalContent;
        btnAddDirect.style.pointerEvents = 'auto';
        window.refreshCartDrawer(true);
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        btnAddDirect.innerHTML = '<span style="color:var(--primary)">Out of Stock</span>';
        setTimeout(() => {
          btnAddDirect.innerHTML = originalContent;
          btnAddDirect.style.pointerEvents = 'auto';
        }, 2000);
      });
      return;
    }

    // Quickview quantity buttons
    const qtyMinus = e.target.closest('#quickview-qty-minus');
    if(qtyMinus) {
      e.preventDefault();
      const input = document.getElementById('quickview-qty');
      if (input) {
        let val = parseInt(input.value) || 1;
        if(val > 1) input.value = val - 1;
      }
      return;
    }
    
    const qtyPlus = e.target.closest('#quickview-qty-plus');
    if(qtyPlus) {
      e.preventDefault();
      const input = document.getElementById('quickview-qty');
      if (input) {
        let val = parseInt(input.value) || 1;
        if (input.hasAttribute('max')) {
          const max = parseInt(input.getAttribute('max'));
          if (val < max) input.value = val + 1;
        } else {
          input.value = val + 1;
        }
      }
      return;
    }

    // Cart Drawer Remove Item
    const removeBtn = e.target.closest('.cart-drawer .btn-remove');
    if (removeBtn) {
      e.preventDefault();
      const removeLink = removeBtn.getAttribute('href');
      if (removeLink) {
        fetch(removeLink)
          .then(() => window.refreshCartDrawer(true))
          .catch(console.error);
      }
      return;
    }

    // Cart Drawer Quantity Buttons
    const cartQtyBtn = e.target.closest('.cart-drawer .btn-qty');
    if (cartQtyBtn) {
      e.preventDefault();
      const changeLink = cartQtyBtn.getAttribute('href');
      if (changeLink) {
        fetch(changeLink)
          .then(() => window.refreshCartDrawer(true))
          .catch(console.error);
      }
      return;
    }
  });

  // Quickview Add to Cart Form Submission
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('#quickview-add-to-cart-form') || (e.target.action && e.target.action.includes('/cart/add') ? e.target : null);
    if(form) {
      e.preventDefault();
      const addBtn = form.querySelector('.btn-quickview-add') || form.querySelector('button[type="submit"]');
      const origText = addBtn ? addBtn.innerHTML : '';
      if(addBtn) {
        addBtn.innerHTML = '<span>Adding...</span>';
        addBtn.disabled = true;
      }

      const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const formData = new FormData(form);

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) return response.json().then(err => { throw err; });
        return response.json();
      })
      .then(() => {
        if(addBtn) {
          addBtn.innerHTML = origText;
          addBtn.disabled = false;
        }
        window.closeQuickview();
        window.refreshCartDrawer(true);
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        if (addBtn) {
          addBtn.innerHTML = '<span style="color:var(--primary)">Failed / Out of stock</span>';
          setTimeout(() => {
            addBtn.innerHTML = origText;
            addBtn.disabled = false;
          }, 2500);
        }
      });
    }
  });

});
